import Marquee from "react-fast-marquee";

const ITEMS = [
  "T700 Raw Carbon Paddles",
  "Tournament Balls",
  "Private Label",
  "OEM / ODM",
  "Custom Manufacturing",
  "Worldwide Shipping",
  "MOQ from 25 Units",
];

const EditorialMarquee = ({ dark = false }) => (
  <div
    className={`overflow-hidden border-y py-5 ${
      dark ? "bg-brand-ink border-white/10" : "bg-white border-black/10"
    }`}
    data-testid="editorial-marquee"
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span
          key={item}
          className={`mx-10 inline-flex items-center gap-10 font-mono text-xs uppercase tracking-[0.3em] ${
            dark ? "text-white/50" : "text-neutral-400"
          }`}
        >
          {item}
          <span className="inline-block h-1.5 w-1.5 bg-brand-red" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
